import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const RouteWithLayoutProtected = (props) => {
  const {
    authenticated = false,
    exact = false,
    layout: Layout,
    component: Component,
    ...rest
  } = props;

  return (
    <Route
      {...rest}
      exact={exact}
      render={(matchProps) =>
        authenticated ? (
          <Layout>
            <Component {...matchProps} />
          </Layout>
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: matchProps.location }
            }}
          />
        )
      }
    />
  );
};

RouteWithLayoutProtected.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  component: PropTypes.any.isRequired,
  exact: PropTypes.bool,
  layout: PropTypes.any.isRequired,
  loading: PropTypes.bool.isRequired,
  path: PropTypes.string
};

const mapStateToProps = (state) => ({
  authenticated: state.AuthReducer.authenticated,
  loading: state.AuthReducer.loading
});

export default connect(mapStateToProps, {})(RouteWithLayoutProtected);
